/**
 * Legacy shim — kept for backwards compatibility.
 *
 * The single source of truth is now src/environments/environment.ts (and the
 * environment.sandbox.ts / environment.prod.ts overrides applied by
 * angular.json fileReplacements at build time).
 *
 * This file simply re-exposes the same value under the old `omApiUrl` field
 * name so existing services (AuthService, PortalNexusService) keep working
 * without code changes.
 */
import { environment as base } from '../../environments/environment';

export const environment = {
  ...base,
  /** @deprecated use `apiUrl` from `src/environments/environment` instead */
  omApiUrl: base.apiUrl,
};
